import { render } from "./ContentPdfs.vue?vue&type=template&id=47e44caa"
import script from "./ContentPdfs.vue?vue&type=script&lang=js"
export * from "./ContentPdfs.vue?vue&type=script&lang=js"

import "./ContentPdfs.vue?vue&type=style&index=0&id=47e44caa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__